export var CircleVariants;
(function (CircleVariants) {
    CircleVariants["primary"] = "primary";
    CircleVariants["secondary"] = "secondary";
})(CircleVariants || (CircleVariants = {}));
export var CircleSizes;
(function (CircleSizes) {
    CircleSizes["tiny"] = "tiny";
    CircleSizes["small"] = "small";
    CircleSizes["medium"] = "medium";
    CircleSizes["large"] = "large";
    CircleSizes["xlarge"] = "xlarge";
})(CircleSizes || (CircleSizes = {}));
export var CircleRadiusSizes;
(function (CircleRadiusSizes) {
    CircleRadiusSizes[CircleRadiusSizes["tiny"] = 8] = "tiny";
    CircleRadiusSizes[CircleRadiusSizes["small"] = 12] = "small";
    CircleRadiusSizes[CircleRadiusSizes["medium"] = 16] = "medium";
    CircleRadiusSizes[CircleRadiusSizes["large"] = 32] = "large";
    CircleRadiusSizes[CircleRadiusSizes["xlarge"] = 64] = "xlarge";
})(CircleRadiusSizes || (CircleRadiusSizes = {}));
//# sourceMappingURL=constants.js.map